import Fonts from './fonts';
import BaseStyles from './basestyles';
import colors from './colorPalette';

export { Fonts, BaseStyles, colors };
